import styled from 'styled-components';

export const NavbarWrapper = styled.div`
  padding: 22px 24px 22px 14px;
  border-bottom: 1px solid var(--light-pink);

  .navbar-label {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NavChildrenContainer = styled.div`
  display: flex;
  align-items: center;

  .ant-btn-default.delete-btn {
    color: var(--error);
    display: flex;
    align-items: center;

    &:hover {
      color: var(--error);
    }
  }

  &.scroll-left-side,
  &.scroll-right-side {
    overflow-x: auto;
    width: max-content;
  }
`;

export const NavSeparator = styled.div`
  width: 1px;
  height: 8px;
  background: var(--secondary);
  opacity: 0.2;
  margin: auto 8px;
`;

export const NavSeparatorProfile = styled.div`
  width: 1px;
  height: 8px;
  background: var(--secondary);
  opacity: 0.2;
  margin: auto 6px;
`;

export const SubNavSeparator = styled.div`
  margin: auto 16px;
  font-weight: 600;
`;
